import { jsxs as s, jsx as i } from "react/jsx-runtime";
import { Loader as g } from "./contact-channels76.js";
import { Show as r } from "./contact-channels77.js";
import { Button as h, Icon as e, Link as x, FlexBox as y } from "@vp/swan";
import { useTranslations as A } from "./contact-channels38.js";
import { useWhatsApp as W } from "./contact-channels7.js";
import m from "./contact-channels93.js";
import u from "./contact-channels94.js";
const N = (f) => {
  var c;
  const { variation: o = "standard", showLoading: b = !0 } = f, { t: a } = A(), { data: n, isLoading: l, isPending: k } = W(), t = !(n != null && n.isAvailable) || l || ((c = n == null ? void 0 : n.plainData) == null ? void 0 : c.link) === "", w = () => {
    if (t)
      return /* @__PURE__ */ s(h, { skin: "secondary", type: "button", iconPosition: "left", disabled: t, children: [
        /* @__PURE__ */ i(e, { src: u }),
        a("whatsApp.button")
      ] });
  }, L = /* @__PURE__ */ s(
    h,
    {
      skin: "secondary",
      type: "button",
      iconPosition: "left",
      render: (d) => {
        var p;
        return /* @__PURE__ */ i(x, { target: "_blank", to: (p = n == null ? void 0 : n.plainData) == null ? void 0 : p.link, className: d.className, children: d.children });
      },
      children: [
        /* @__PURE__ */ i(e, { src: m }),
        a("whatsApp.button")
      ]
    }
  );
  return /* @__PURE__ */ i(g, { skeletonLines: 1, skeletonLineWidths: "narrow", isLoading: l || k, showLoading: b, children: /* @__PURE__ */ i(y, { style: { width: "100%" }, pt: o === "standard" ? "5" : void 0, children: /* @__PURE__ */ s(r, { children: [
    /* @__PURE__ */ i(r.When, { isTrue: o === "standard", children: t ? w() : L }),
    /* @__PURE__ */ i(r.When, { isTrue: o === "minimal", children: /* @__PURE__ */ i(e, { src: t ? u : m }) })
  ] }) }) });
};
export {
  N as WhatsAppFooter
};
//# sourceMappingURL=contact-channels35.js.map
